import { useState, useEffect, useCallback } from 'react';
import { fetchPublishedPlans } from '../api';

const useLoadPublishedPlans = (user) => {
  const [publishedPlans, setPublishedPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadPublishedPlans = useCallback(async () => {
    if (!user?.username) {
      setPublishedPlans([]);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      const result = await fetchPublishedPlans(user.username);
      
      if (result.error) {
        setError(result.error);
        setPublishedPlans([]);
      } else if (result.success) {
        setPublishedPlans(result.plans || []);
        setError(null);
      } else {
        setError('Unerwartete Antwort vom Server');
        setPublishedPlans([]);
      }
    } catch (err) {
      console.error('Fehler beim Laden der veröffentlichten Pläne:', err);
      setError('Verbindungsfehler beim Laden der veröffentlichten Pläne');
      setPublishedPlans([]);
    } finally {
      setLoading(false);
    }
  }, [user?.username]);

  useEffect(() => {
    loadPublishedPlans();
  }, [loadPublishedPlans]);

  const refresh = useCallback(() => {
    loadPublishedPlans();
  }, [loadPublishedPlans]);

  return {
    publishedPlans,
    loading,
    error,
    refresh
  };
};

export default useLoadPublishedPlans;